export default "<app-admin-login></app-admin-login>\r\n<router-outlet></router-outlet>"